module.exports = __webpack_public_path__ + "img/50x50_yesil.1b8b0a09.gif";